import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';

export default function DataProtectionPolicy() {
  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight">Policy aziendali sulla protezione dei dati</h1>
        <p className="text-sm text-muted-foreground">
          Questo documento descrive i principi generali adottati dall&apos;organizzazione per garantire la
          riservatezza, l&apos;integrità e la disponibilità dei dati trattati all&apos;interno dell&apos;applicazione.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>1. Ambito di applicazione</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 text-sm text-muted-foreground">
          <p>
            Le presenti policy si applicano a tutti gli utenti autorizzati che accedono all&apos;applicazione e
            trattano dati personali, aziendali o comunque riservati, inclusi ma non limitati a:
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>dati anagrafici di clienti, controparti e contatti;</li>
            <li>dati relativi a pratiche, dossier e negoziazioni;</li>
            <li>dati provenienti da sistemi esterni integrati (es. Open Banking, sistemi gestionali, telefonia);</li>
            <li>informazioni interne sull&apos;organizzazione e sugli asset aziendali.</li>
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>2. Principi di trattamento</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 text-sm text-muted-foreground">
          <p>I dati sono trattati nel rispetto dei seguenti principi generali:</p>
          <ul className="list-disc list-inside space-y-1">
            <li><span className="font-medium">Liceità, correttezza e trasparenza</span>: ogni trattamento avviene su base giuridica adeguata e in modo trasparente nei confronti degli interessati.</li>
            <li><span className="font-medium">Limitazione della finalità</span>: i dati sono utilizzati esclusivamente per le finalità operative e di servizio previste.</li>
            <li><span className="font-medium">Minimizzazione</span>: si trattano solo i dati strettamente necessari all&apos;esecuzione delle attività.</li>
            <li><span className="font-medium">Integrità e riservatezza</span>: i dati sono protetti contro accessi non autorizzati, uso improprio, perdita o distruzione.</li>
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>3. Accesso all&apos;applicazione</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 text-sm text-muted-foreground">
          <ul className="list-disc list-inside space-y-1">
            <li>L&apos;accesso all&apos;applicazione è consentito solo a utenti autorizzati mediante credenziali personali.</li>
            <li>È vietata la condivisione delle credenziali di accesso con terzi.</li>
            <li>Gli utenti sono responsabili della custodia sicura delle proprie credenziali.</li>
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>4. Blocco sessione per inattività</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 text-sm text-muted-foreground">
          <p>
            Per ridurre il rischio di accessi non autorizzati a postazione incustodita, l&apos;applicazione applica un
            meccanismo di blocco automatico della sessione dopo un periodo di inattività.
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>in caso di inattività prolungata la sessione viene bloccata e l&apos;utente deve reinserire la password;</li>
            <li>dopo un ulteriore periodo di inattività la sessione viene chiusa e l&apos;utente deve eseguire un nuovo login;</li>
            <li>tutti i tentativi di sblocco vengono registrati a fini di audit di sicurezza.</li>
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>5. Ruoli e responsabilità</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 text-sm text-muted-foreground">
          <ul className="list-disc list-inside space-y-1">
            <li><span className="font-medium">Amministratori di sistema</span>: configurazione degli accessi, gestione ruoli e monitoraggio tecnico dell&apos;applicazione.</li>
            <li><span className="font-medium">Responsabili di funzione</span>: definizione delle regole operative di utilizzo e supervisione delle attività svolte dai propri team.</li>
            <li><span className="font-medium">Utenti operativi</span>: utilizzo diligente dell&apos;applicazione nel rispetto delle presenti policy e delle procedure interne.</li>
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>6. Conservazione e protezione dei dati</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 text-sm text-muted-foreground">
          <ul className="list-disc list-inside space-y-1">
            <li>l&apos;accesso ai dati è profilato in base al ruolo dell&apos;utente e al principio di necessità;</li>
            <li>eventuali log di accesso e attività sono conservati per un periodo adeguato alle esigenze di audit;</li>
            <li>le esportazioni di dati devono essere effettuate solo quando strettamente necessario e conservate in modo sicuro.</li>
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>7. Segnalazione incidenti</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 text-sm text-muted-foreground">
          <p>
            Ogni anomalia, sospetto accesso non autorizzato o potenziale violazione di dati deve essere segnalata senza
            ritardo alle funzioni aziendali preposte (es. IT, Responsabile Sicurezza o DPO, se nominato).
          </p>
        </CardContent>
      </Card>

      <p className="text-xs text-muted-foreground">
        Questo testo ha carattere esemplificativo e deve essere adattato e integrato in base alle policy aziendali,
        alle procedure interne e alla normativa applicabile (es. GDPR).
      </p>
    </div>
  );
}

